var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0001 1C5.47791 1 1 5.5904 1 11.2532C1 15.7833 3.86533 19.6266 7.83867 20.9824C8.33844 21.0773 8.52192 20.76 8.52192 20.4891C8.52192 20.2446 8.51265 19.437 8.50834 18.5802C5.72631 19.2005 5.13927 17.3705 5.13927 17.3705C4.68437 16.1854 4.02894 15.8702 4.02894 15.8702C3.12163 15.2339 4.09733 15.2469 4.09733 15.2469C5.10151 15.3193 5.63026 16.3035 5.63026 16.3035C6.52217 17.871 7.96965 17.4178 8.5403 17.1559C8.63006 16.4932 8.88922 16.0409 9.1752 15.7848C6.95405 15.5256 4.61913 14.6464 4.61913 10.7177C4.61913 9.59825 5.00977 8.6836 5.64947 7.96556C5.54564 7.70731 5.20335 6.66448 5.74635 5.25218C5.74635 5.25218 6.58609 4.97661 8.49708 6.30317C9.29476 6.07599 10.1502 5.96206 11.0001 5.95816C11.8499 5.96206 12.7061 6.07599 13.5052 6.30317C15.4139 4.97661 16.2525 5.25218 16.2525 5.25218C16.7968 6.66448 16.4544 7.70731 16.3505 7.96556C16.9917 8.6836 17.3797 9.59825 17.3797 10.7177C17.3797 14.6557 15.0403 15.5228 12.8135 15.7767C13.1722 16.0949 13.4918 16.7188 13.4918 17.6754C13.4918 19.0473 13.4802 20.1514 13.4802 20.4891C13.4802 20.762 13.6602 21.0817 14.1671 20.981C18.1383 19.6237 21 15.7818 21 11.2532C21 5.5904 16.5227 1 11.0001 1Z",
    fill: "#FDF4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.0ff7197a89d4d97bd568f4ba32e12917.svg";
export { ForwardRef as ReactComponent };